/* eslint-disable react-hooks/exhaustive-deps */
import {
  BookText,
  Calendar,
  ChartPie,
  ChevronRight,
  FileText,
  Mail,
  Phone,
} from "lucide-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { fetchAdminData, fetchBankLeadData } from "../../../api";
import { Oppsummering } from "./oppsummering";
import { Fremdriftsplan } from "./Fremdriftsplan";
import { FremdriftsplanOg } from "./Fremdriftsplan-og";
import { Documenters } from "./document";
import { formatNorwegianPhone2 } from "../../../lib/utils";

export const BankLeadsDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const id = pathSegments.length > 2 ? pathSegments[2] : null;
  const [loading, setLoading] = useState(true);
  const [bankData, setBankData] = useState<any>();

  const getData = useCallback(async () => {
    if (!id) return;

    setLoading(true);
    try {
      const data = await fetchBankLeadData(id);
      if (data) {
        setBankData(data);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    if (!id) {
      setLoading(false);
      return;
    }

    getData();
  }, [getData]);

  const [activeTab, setActiveTab] = useState<any>(0);
  const tabData = [
    { label: "Summary", icon: <BookText className="w-5 h-5 md:w-6 md:h-6" /> },
    // {
    //   label: "Forhåndstakst",
    //   icon: <Banknote className="w-5 h-5 md:w-6 md:h-6" />,
    // },
    {
      label: "Fremdrifts- og faktureringsplan",
      icon: <ChartPie className="w-5 h-5 md:w-6 md:h-6" />,
    },
    {
      label: "Dokumentasjon",
      icon: <FileText className="w-5 h-5 md:w-6 md:h-6" />,
    },
    {
      label: "Fremdriftsplan",
      icon: <Calendar className="w-5 h-5 md:w-6 md:h-6" />,
    },
  ];
  useEffect(() => {
    const timeout = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);

    return () => clearTimeout(timeout);
  }, [activeTab]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const step = searchParams.get("step");
    if (step) {
      setActiveTab(Number(step));
      searchParams.delete("step");

      navigate(`${location.pathname}?${searchParams.toString()}`, {
        replace: true,
      });
    }
  }, []);

  const [assignUser, setAssignUser] = useState<any>(null);

  useEffect(() => {
    const getData = async () => {
      const data: any = await fetchAdminData(bankData?.assignedTo);
      if (data) {
        setAssignUser(data);
      }
    };
    if (bankData && bankData?.assignedTo) {
      getData();
    }
  }, [bankData]);

  const tabRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = tabRef.current;
    if (!container) return;

    const activeButton = container.querySelectorAll("button")[activeTab];
    if (activeButton) {
      const containerRect = container.getBoundingClientRect();
      const buttonRect = activeButton.getBoundingClientRect();
      const scrollLeft =
        activeButton.offsetLeft -
        containerRect.width / 2 +
        buttonRect.width / 2;

      container.scrollTo({
        left: scrollLeft,
        behavior: "smooth",
      });
    }
  }, [activeTab]);

  return (
    <>
      <div className="p-2 pt-0">
        <div className="border border-gray3 rounded-lg">
          <div className="p-4 flex flex-col gap-3 md:gap-5 border-b border-gray3">
            <div className="flex items-center gap-1 flex-wrap">
              <Link
                to={"/agent-leads"}
                className="text-gray4 text-xs md:text-sm cursor-pointer"
              >
                Bank Leads
              </Link>
              <ChevronRight className="h-4 w-4 text-gray5" />
              <span className="text-black3 text-sm md:text-base lg:text-lg font-bold">
                Lead Details
              </span>
            </div>
            <div>
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-2">
                <div className="text-darkBlack text-lg md:text-xl desktop:text-2xl font-semibold">
                  {bankData?.Kunden?.Kundeinformasjon[0]?.f_name}{" "}
                  {bankData?.Kunden?.Kundeinformasjon[0]?.l_name}{" "}
                </div>
              </div>
              <div className="flex md:items-center gap-2 sm:gap-4 md:gap-6 flex-col md:flex-row">
                <p className="text-black3 text-xs md:text-sm font-medium">
                  {bankData?.plotHusmodell?.plot?.address}
                </p>
                <div className="flex items-center gap-2 md:gap-3 flex-wrap">
                  <div className="flex items-center gap-2">
                    <Mail className="w-5 h-5 text-gray5" />
                    <span className="text-gray4 text-xs md:text-sm">
                      {bankData?.Kunden?.Kundeinformasjon[0]?.EPost}
                    </span>
                  </div>
                  <div className="h-3 border-l border-grey"></div>
                  <div className="flex items-center gap-2">
                    <Phone className="w-5 h-5 text-gray5" />
                    <span className="text-gray4 text-xs md:text-sm">
                      {formatNorwegianPhone2(
                        bankData?.Kunden?.Kundeinformasjon[0]?.mobileNummer
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {assignUser && (
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 md:gap-3">
                <span className="text-darkBlack text-xs md:text-sm font-semibold flex items-center gap-2">
                  Bank Agent:{" "}
                  <span className="text-black3 font-medium">
                    {assignUser?.f_name ?? assignUser?.name}{" "}
                    {assignUser?.l_name ?? ""}
                  </span>
                </span>{" "}
                <div className="h-3 border-l border-grey hidden sm:block"></div>
                <div className="flex items-center gap-2">
                  <Mail className="w-5 h-5 text-gray5" />
                  <span className="text-gray4 text-xs md:text-sm">
                    {assignUser?.email}
                  </span>
                </div>
              </div>
            )}
          </div>
          <div className="relative flex flex-col lg:flex-row items-start gap-6 px-3 lg:px-4 py-4 lg:py-5">
             <div
              ref={tabRef}
              className="overflow-x-auto w-full lg:w-[300px] HideScrollbar"
            >
              <div className="flex lg:flex-col gap-2 bg-white">
                {tabData.map((tab, index) => (
                  <button
                    key={index}
                    className={`text-sm whitespace-nowrap relative ${
                      id ? "cursor-pointer" : "cursor-auto"
                    } flex items-center gap-2 text-darkBlack py-2 px-2 md:px-3 rounded-lg ${
                      activeTab === index
                        ? "font-semibold bg-darkGreen2 text-primary"
                        : "text-gray5"
                    }`}
                    onClick={() => setActiveTab(index)}
                    style={{
                      boxShadow:
                        activeTab === index ? "0px 1px 2px 0px #1018281A" : "",
                    }}
                  >
                    {activeTab === index && (
                      <div
                        className="absolute left-1 border-l-2 border-green3 h-5"
                        style={{
                          boxShadow: "3px 0 24px 4px rgba(0, 136, 70, 0.6)",
                          backdropFilter: "blur(8px)",
                          borderRadius: "2px",
                        }}
                      ></div>
                    )}
                    <span
                      className={`${activeTab === index ? "text-white" : ""}`}
                    >
                      {tab.icon}
                    </span>
                    <span
                      className={`${
                        activeTab === index ? "text-white" : "text-gray4"
                      }`}
                    >
                      {tab.label}
                    </span>
                  </button>
                ))}
              </div>
            </div>

            <div className="w-full lg:w-[calc(100%-300px)]">
              {activeTab === 0 && (
                <Oppsummering
                  bankData={bankData}
                  loading={loading}
                  setActiveTab={setActiveTab}
                />
              )}
              {/* {activeTab === 1 && (
              <Forhandstakst
                bankData={bankData}
                setActiveTab={setActiveTab}
                getData={getData}
              />
            )} */}
              {activeTab === 1 && (
                <FremdriftsplanOg
                  setActiveTab={setActiveTab}
                  getData={getData}
                />
              )}
              {activeTab === 2 && (
                <Documenters setActiveTab={setActiveTab} getData={getData} />
              )}
              {activeTab === 3 && (
                <Fremdriftsplan
                  bankData={bankData}
                  loading={loading}
                  getData={getData}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
